export * from './regex';

export const COOKIES = {
  abTestingCookie: 'ab-optimize',
  csrf: 'CSRF_TOKEN',
  cart: 'bc_cartId',
  customer: 'SHOP_TOKEN',
  impersonation: '_bulk_ci',
  impersonationCustomerId: '_bulk_cid',
  session: 'LOG_SESSION',
  passwordResetEmail: 'reset_password_email',
  tracking: '_bulk_c_uuid',
  intercom: 'intercom-session',
  freeSamplePageFreeShipping: 'bulk_free_sample_promo',
};

export const FIXED_PRODUCT_IDS = {
  freeSample: 686,
} as const;

export const SEARCH_INDEXES = {
  PRODUCTS_BEST_SELLING: 'sanity_production_products_best_selling',
  PRODUCTS_TOP_RATED: 'sanity_production_top_rated',
  // PRODUCTS_PRICE_PER_SERVE_LOW_TO_HIGH: 'sanity_production_price_per_serve_asc',
  // PRODUCTS_PRICE_PER_SERVE_HIGH_TO_LOW:
  //   'sanity_production_price_per_serve_desc',
  PRODUCTS_PRICE_ASC: 'sanity_production_products_price_asc',
  PRODUCTS_PRICE_DESC: 'sanity_production_products_price_desc',
  PRODUCTS: 'sanity_production_products',
  CATEGORIES: 'sanity_production_categories',
  PAGES: 'sanity_production_pages',
  BLOGS: 'sanity_production_blogs',
  AMBASSADORS: 'sanity_production_ambassadors',
  AUTHORS: 'sanity_production_authors',
  FAQS: 'sanity_production_faqs',
} as const;

export const PRODUCT_SEARCH_INDEXES = Object.keys(SEARCH_INDEXES).reduce(
  (acc, key) => {
    if (key.includes('PRODUCTS')) {
      acc.push(SEARCH_INDEXES[key]);
    }
    return acc;
  },
  [] as Array<string>
);

// These keys need to be the same as the SEARCH_INDEXES
export const PRODUCT_SORT_OPTIONS = {
  PRODUCTS: 'Featured',
  PRODUCTS_BEST_SELLING: 'Best Selling',
  PRODUCTS_TOP_RATED: 'Star Rating',
  // PRODUCTS_PRICE_PER_SERVE_LOW_TO_HIGH: 'Price per serve: low to high',
  // PRODUCTS_PRICE_PER_SERVE_HIGH_TO_LOW: 'Price per serve: high to low',
  PRODUCTS_PRICE_ASC: 'Price: low to high',
  PRODUCTS_PRICE_DESC: 'Price: high to low',
  // FAVOURITES: 'Favourites', TODO: need to work out how this would work with our sanity queries
};

export const CONFIG = {
  categoryHitsPerPage: 36,
  searchResultsHitsPerPage: 12,
  autocompleteProducts: 6,
  autocompleteBlogs: 4,
  autocompletePopularResults: 8,
  defaultIconSize: '1rem',
};

export const BIG_COMMERCE_CUSTOMER_ATTRIBUTES = {
  ott: 1, // one time token for password resets
};

export const SWR_KEYS = {
  cart: 'cartFetcher',
  customer: '/api/customer/current',
  addresses: '/api/customer/address',
  wishlist: 'wishlistFetcher',
  alerts: '/api/alerts',
  menuBanner: '/api/menuBannerCTAs',
  productsOrdered: '/api/customer/products-ordered',
};

export const CUSTOMER_GROUPS = {
  ALL: 2,
  BANTER: 3,
  AMBASSADORS: 5,
  PT_REFERRAL_TRIAL: 9,
};

export const PT_REFERRAL_GROUPS = [
  CUSTOMER_GROUPS.BANTER,
  CUSTOMER_GROUPS.AMBASSADORS,
  CUSTOMER_GROUPS.PT_REFERRAL_TRIAL,
  CUSTOMER_GROUPS.ALL,
];

export const states: { [index: string]: string } = {
  'Australian Capital Territory': 'Australian Capital Territory',
  'New South Wales': 'New South Wales',
  'Northern Territory': 'Northern Territory',
  Queensland: 'Queensland',
  'South Australia': 'South Australia',
  Tasmania: 'Tasmania',
  Victoria: 'Victoria',
  'Western Australia': 'Western Australia',
};

export const statesMap = {
  ACT: 'Australian Capital Territory',
  NSW: 'New South Wales',
  NT: 'Northern Territory',
  QLD: 'Queensland',
  SA: 'South Australia',
  TAS: 'Tasmania',
  VIC: 'Victoria',
  WA: 'Western Australia',
};

export const countries: { [index: string]: string } = {
  AU: 'Australia',
  NZ: 'New Zealand',
};

export const MIN_BROWSER_VERSIONS = {
  chrome: 129,
  firefox: 133,
  safari: 16,
  edge: 131,
};

export const SUPPORTED_BROWSERS = [
  {
    name: `Chrome ${MIN_BROWSER_VERSIONS.chrome}+`,
    image: '/images/browser-icons/Browser-chrome-logo-128.webp',
    download: 'https://www.google.com/intl/en_au/chrome/',
  },
  {
    name: `Safari ${MIN_BROWSER_VERSIONS.safari}+`,
    image: '/images/browser-icons/Browser-safari-logo-128.webp',
    download: 'https://support.apple.com/en-au/safari',
  },
  {
    name: `Firefox ${MIN_BROWSER_VERSIONS.firefox}+`,
    image: '/images/browser-icons/Browser-firefox-logo-128.webp',
    download: 'https://www.mozilla.org/en-US/firefox/new/',
  },
  {
    name: `Edge ${MIN_BROWSER_VERSIONS.edge}+`,
    image: '/images/browser-icons/Browser-edge-logo-128.webp',
    download: 'https://www.microsoft.com/en-us/edge',
  },
];

export const FORM_IDS = {
  CUSTOMER_SOURCE: '19829d16-989c-4e4f-9d5c-d119d35f867c',
  SUGGEST_FLAVOUR: '446a7119-ed0c-4147-bd6a-40ec58c3abd9',
  FREE_SAMPLE: '37f4ad71-c813-4481-9274-2c516ead46d0',
  CUSTOMER_SENTIMENT: '2350df66-dd73-44e0-b888-5ef18eac5e02',
  CONTACT_US: 'c4d2754c-ee6e-447a-87c5-5f01ee69d666',
};

export const INTERCOM_TICKET_IDS = {
  CONTACT_US: 121005,
  RETURNS: 121006,
};

export const LONG_MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const RATE_LIMITING = {
  LIMIT_PER_DURATION: 5,
  DURATION: 300,
  TIGHT_LIMIT_PER_DURATION: 3,
  TIGHT_DURATION: 10,
  TIGHT_PUNISHMENT_DURATION: 1800,
  PASSWORD_RESET_KEY_PREFIX: 'rate_limit:password-reset-request',
  VERIFY_KEY_PREFIX: 'rate_limit:verify-request',
};

export const KLAVIYO_REVISION_VERSION = '2025-01-15';

export const KLAVIYO_LISTS = {
  NEWSLETTER: 'HAdn2c',
  SMS: 'WfDam9',
  FREE_SAMPLE_REQUESTED: 'KTeqHs',
  NOTIFY_STOCK: 'yY5BBD',
};

export const REWARD_TIERS = {
  WELCOME: {
    earn: 3,
    spend: 0,
  },
  BRONZE: { earn: 4, spend: 250 },
  SILVER: { earn: 5, spend: 500 },
  GOLD: { earn: 6, spend: 1500 },
};

export const LL_REWARDS = {
  BIRTHDAY: {
    earn: 500,
  },
  SOCIAL: { earn: 50 },
  EMAIL: { earn: 100 },
};

export const LOCAL_STORAGE_KEYS = {
  RECENTLY_VIEWED_PRODUCTS: 'recentlyViewed',
  RECENTLY_VIEWED_BLOGS: 'recentlyViewedBlogs',
  RECENTLY_VIEWED_PAGES: 'recentlyViewedPages',
};

export const MAX_DISPLAY_REVIEW_COUNT = 50;